import './customer-active-deliveries-view/customer-active-deliveries-view.component';
import './customer-active-deliveries-view/customer-active-deliveries-view.scss';

import './customer-address-select/customer-address-select.component';
import './customer-address-select/customer-address-select.scss';

import './customer-addresses-table/customer-addresses-table.component';
import './customer-addresses-table/customer-addresses-table.scss';

import './customer-addresses-table-row/customer-addresses-table-row.component';
import './customer-addresses-table-row/customer-addresses-table-row.scss';

import './customer-addresses-view/customer-addresses-view.component';
import './customer-addresses-view/customer-addresses-view.scss';

import './customer-delivery-history-view/customer-delivery-history-view.component';
import './customer-delivery-history-view/customer-delivery-history-view.scss';

import './customer-link/customer-link.component';
import './customer-link/customer-link.scss';

import './customer-select/customer-select.component';
import './customer-select/customer-select.scss';

import './customer-select-list/customer-select-list.component';
import './customer-select-list/customer-select-list.scss';

import './customer-view/customer-view.component';
import './customer-view/customer-view.scss';

import './customers-autocomplete/customers-autocomplete.component';
import './customers-autocomplete/customers-autocomplete.scss';

import './customers-display-list/customers-display-list.component';
import './customers-display-list/customers-display-list.scss';

import './customers-multi-select/customers-multi-select.component';
import './customers-multi-select/customers-multi-select.scss';

import './customers-multi-select-list/customers-multi-select-list.component';
import './customers-multi-select-list/customers-multi-select-list.scss';

import './customers-table/customers-table.component';
import './customers-table/customers-table.scss';

import './customers-table-row/customers-table-row.component';
import './customers-table-row/customers-table-row.scss';

import './customers-view/customers-view.component';

import './customer-select-item/customer-select-item.component';
import './customer-select-item/customer-select-item.scss';


